




































































































































































import Vue from "@/shared/node_modules/vue";
import Component from "@/shared/node_modules/vue-class-component";
import { Settings } from "@/shared/core/services/configService";
import { CrudService } from "@/shared/core/services/crudService";
import DynamicField from "@/shared/components/dynamicForm/dynamicField.vue";
import CtaButton from "@/shared/components/ctaButton/ctaButton.vue";
import { InputType } from "@/shared/components/dynamicForm/inputTypes";
import DatePicker from "@/shared/components/datePicker/datePicker.vue";
import { DateHelper } from "@/shared/core/helpers/dateHelper";
import VoiceRecorder from "@/shared/components/voiceRecorder/voiceRecorder.vue";
import Popup from "@/shared/components/popup/popup.vue";

@Component({
  components: {
    DynamicField,
    CtaButton,
    DatePicker,
    VoiceRecorder,
    Popup,
  },
})
export default class SurveyAnswerPage extends Vue {
  state: string = "loading";
  message: string = "";
  surveyName: string = "";
  description: string = "";
  preview: boolean = false;
  questions: any[] = [];
  index: number = 0;
  transitionName: string = "survey-fwd";
  validationError: string = "";
  submitError: string = "";
  submitting: boolean = false;
  showVoiceInfo: boolean = false;

  get clinicName(): string {
    const settings =
      (this.$store && this.$store.state && this.$store.state.settings) || {};
    return settings.Title || this.$t("your clinic").toString();
  }

  get voiceInfoPurpose(): string {
    return this.$t(
      "Purpose: to help {clinic} prioritize which responses to review first. It is not a diagnosis or an automated decision.",
    )
      .toString()
      .replace("{clinic}", this.clinicName);
  }

  get voiceInfoController(): string {
    return this.$t(
      "Data controller: {clinic}. To exercise your rights (access, rectification, erasure), contact your clinic.",
    )
      .toString()
      .replace("{clinic}", this.clinicName);
  }

  get token(): string {
    if (this.$route.path.indexOf("/survey/preview") === 0) {
      return (this.$route.query.t as string) || "";
    }
    return (this.$route.params.token as string) || "";
  }

  get current(): any {
    return this.questions[this.index] || { fdata: {} };
  }

  get isLast(): boolean {
    return this.index === this.questions.length - 1;
  }

  get progressStyle(): any {
    const pct = this.questions.length === 0 ? 0 : Math.round(((this.index + 1) / this.questions.length) * 100);
    return { width: pct + "%" };
  }

  async created() {
    await this.loadDefinition();
  }

  async loadDefinition() {
    const url = `${Settings.HostName}/api/surveys/answer/def`;
    const res = await new CrudService().httpPost(url, { token: this.token });
    if (res == null) {
      this.showMessage(this.$t("Crash").toString());
      return;
    }
    if (res.ok !== true) {
      this.showMessage(this.messageForStatus(res.status));
      return;
    }
    const model = res.model;
    if (model.status === "answered") {
      this.showMessage(this.$t("You already answered this survey, thank you").toString());
      return;
    }
    if (model.status === "expired") {
      this.showMessage(this.$t("This link has expired").toString());
      return;
    }
    if (model.status !== "ok") {
      this.showMessage(this.messageForStatus(model.status));
      return;
    }
    this.preview = model.preview === true;
    this.surveyName = model.name || "";
    this.description = model.description || "";
    this.questions = (model.questions || []).map((q: any) => this.toQuestion(q));
    if (this.questions.length === 0) {
      this.showMessage(this.$t("Survey not available").toString());
      return;
    }
    this.state = "welcome";
  }

  messageForStatus(status: string) {
    if (status === "expired") {
      return this.$t("This link has expired").toString();
    }
    if (status === "answered") {
      return this.$t("You already answered this survey, thank you").toString();
    }
    if (status === "unavailable") {
      return this.$t("Survey not available").toString();
    }
    return this.$t("This link is not valid").toString();
  }

  showMessage(msg: string) {
    this.message = msg;
    this.state = "message";
  }

  // Adapter SurveyQuestionDto -> fdata consumed by the shared DynamicField inputs.
  toQuestion(q: any) {
    const fdata: any = {
      field: "q" + q.id,
      headerName: q.text,
      required: q.required === true,
      editInputType: InputType.Text,
      floatingFilterComponentParams: {},
      value: null,
    };
    switch (q.type) {
      case 1:
        fdata.editInputType = InputType.TextArea;
        break;
      case 3:
        fdata.editInputType = InputType.Picklist;
        for (const opt of q.options || []) {
          fdata.floatingFilterComponentParams[opt] = opt;
        }
        break;
      case 4:
        fdata.isNumber__ = true;
        break;
      case 5:
        fdata.editInputType = InputType.Date;
        break;
    }
    return {
      id: q.id,
      text: q.text,
      help: q.help,
      type: q.type,
      scaleMax: q.scaleMax,
      min: q.min == null ? null : q.min,
      max: q.max == null ? null : q.max,
      required: q.required === true,
      fdata,
    };
  }

  get scaleMax(): number {
    return this.current && this.current.scaleMax === 5 ? 5 : 10;
  }

  setScale(n: number) {
    this.validationError = "";
    this.$set(this.current.fdata, "value", String(n));
  }

  moveScale(delta: number) {
    const value = parseInt(this.current.fdata.value, 10);
    const next = isNaN(value) ? 1 : Math.min(Math.max(value + delta, 1), this.scaleMax);
    this.setScale(next);
  }

  start() {
    this.index = 0;
    this.state = "question";
  }

  setYesNo(value: string) {
    this.validationError = "";
    this.$set(this.current.fdata, "value", value);
  }

  // Keeps the picker filled when navigating back to an already answered date question.
  get currentDate(): Date | null {
    const v = this.current == null ? null : this.current.fdata.value;
    if (v === null || v === undefined || v === "") {
      return null;
    }
    const d = DateHelper.toSystemDate(v.toString());
    return d === undefined ? null : d;
  }

  setDate(e: any) {
    this.validationError = "";
    const value = e == null || e.date == null ? null : e.systemStrDate;
    this.$set(this.current.fdata, "value", value);
  }

  isEmpty(q: any): boolean {
    const v = q.fdata.value;
    if (v === null || v === undefined) {
      return true;
    }
    if (q.type === 3) {
      return v === -1 || v === "-1" || v === "";
    }
    if (q.type === 6) {
      return !v.audioBase64 || !v.audioMimeType;
    }
    return v.toString().trim() === "";
  }

  validateCurrent(): boolean {
    this.validationError = "";
    if (this.current.required && this.isEmpty(this.current)) {
      this.validationError = this.$t("Required").toString();
      return false;
    }
    // Same rule the backend applies (comma or dot, no exponents), so it is said here
    // instead of failing the whole submit at the end.
    if (this.current.type === 4 && !this.isEmpty(this.current)) {
      const raw = this.current.fdata.value.toString().trim().replace(",", ".");
      if (!/^[-+]?\d*\.?\d+$/.test(raw)) {
        this.validationError = this.$t("Must be a number").toString();
        return false;
      }
      const num = parseFloat(raw);
      const min = this.current.min;
      const max = this.current.max;
      if ((min != null && num < min) || (max != null && num > max)) {
        this.validationError = this.$t("Must be between {min} and {max}")
          .toString()
          .replace("{min}", min == null ? "-" : String(min))
          .replace("{max}", max == null ? "-" : String(max));
        return false;
      }
    }
    return true;
  }

  // Enter inside a text-like input advances like the Next button; textareas keep
  // Enter for newlines and focused buttons keep their own click behavior.
  onEnter(e: KeyboardEvent) {
    const tag = e.target == null ? "" : (e.target as HTMLElement).tagName.toLowerCase();
    if (tag !== "input") {
      return;
    }
    e.preventDefault();
    if (this.isLast) {
      if (!this.preview) {
        this.submit();
      }
      return;
    }
    this.next();
  }

  next() {
    if (!this.validateCurrent()) {
      return;
    }
    if (!this.isLast) {
      this.transitionName = "survey-fwd";
      this.index += 1;
    }
  }

  back() {
    this.validationError = "";
    this.submitError = "";
    if (this.index > 0) {
      this.transitionName = "survey-back";
      this.index -= 1;
    }
  }

  async submit() {
    if (this.submitting || this.preview) {
      return;
    }
    if (!this.validateCurrent()) {
      return;
    }
    this.submitError = "";
    this.submitting = true;

    const answered = this.questions.filter((q) => !this.isEmpty(q));
    const answers = answered
      .map((q) => q.type === 6
        ? {
            questionId: q.id,
            audioBase64: q.fdata.value.audioBase64,
            audioMimeType: q.fdata.value.audioMimeType,
          }
        : { questionId: q.id, value: q.fdata.value.toString() });
    const voiceAnswers = answered.filter((q) => q.type === 6);
    const voicePrivacyAccepted =
      voiceAnswers.length > 0 &&
      voiceAnswers.every((q) => q.fdata.value.privacyAccepted === true);

    const url = `${Settings.HostName}/api/surveys/answer/submit`;
    const res = await new CrudService().httpPost(url, {
      token: this.token,
      answers,
      voicePrivacyAccepted,
    });
    this.submitting = false;

    if (res == null) {
      // Network error or lost response: retry is safe, closing is idempotent server-side.
      this.submitError = this.$t("Could not send, please retry").toString();
      return;
    }
    if (res.ok !== true) {
      this.submitError = res.errorMsg || this.$t("Could not send, please retry").toString();
      return;
    }
    this.state = "thanks";
  }
}
